// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ByteOrder } from "./byte-order";
import { StructLayout, StructLayoutT, verifyStructLayout } from "./struct-layout";

export class StructDecode implements flatbuffers.IUnpackableObject<StructDecodeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): StructDecode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsStructDecode(bb: flatbuffers.ByteBuffer, obj?: StructDecode): StructDecode {
    return (obj || new StructDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsStructDecode(
    bb: flatbuffers.ByteBuffer,
    obj?: StructDecode,
  ): StructDecode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new StructDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  structName(): string;
  structName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  structName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  byteOrder(): ByteOrder | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  layouts(index: number, obj?: StructLayout): StructLayout | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new StructLayout()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  layoutsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startStructDecode(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addStructName(builder: flatbuffers.Builder, structNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, structNameOffset, 0);
  }

  static addByteOrder(builder: flatbuffers.Builder, byteOrder: ByteOrder) {
    builder.addFieldInt8(1, byteOrder, null);
  }

  static addLayouts(builder: flatbuffers.Builder, layoutsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, layoutsOffset, 0);
  }

  static createLayoutsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLayoutsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endStructDecode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // struct_name
    builder.requiredField(offset, 8); // layouts
    return offset;
  }

  static createStructDecode(
    builder: flatbuffers.Builder,
    structNameOffset: flatbuffers.Offset,
    byteOrder: ByteOrder | null,
    layoutsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    StructDecode.startStructDecode(builder);
    StructDecode.addStructName(builder, structNameOffset);
    if (byteOrder !== null) StructDecode.addByteOrder(builder, byteOrder);
    StructDecode.addLayouts(builder, layoutsOffset);
    return StructDecode.endStructDecode(builder);
  }

  unpack(): StructDecodeT {
    return new StructDecodeT(
      this.structName(),
      this.byteOrder(),
      this.bb!.createObjList<StructLayout, StructLayoutT>(
        this.layouts.bind(this),
        this.layoutsLength(),
      ),
    );
  }

  unpackTo(_o: StructDecodeT): void {
    _o.structName = this.structName();
    _o.byteOrder = this.byteOrder();
    _o.layouts = this.bb!.createObjList<StructLayout, StructLayoutT>(
      this.layouts.bind(this),
      this.layoutsLength(),
    );
  }

  unpackFields(...fields: string[]): StructDecodeT {
    const t = new StructDecodeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("struct_name")) {
      t.structName = this.structName();
    }
    if (fieldSet.has("byte_order")) {
      t.byteOrder = this.byteOrder();
    }
    if (fieldSet.has("layouts")) {
      t.layouts = this.bb!.createObjList<StructLayout, StructLayoutT>(
        this.layouts.bind(this),
        this.layoutsLength(),
      );
    }
    return t;
  }
}

export class StructDecodeT implements flatbuffers.IGeneratedObject {
  constructor(
    public structName: string | Uint8Array | null = null,
    public byteOrder: ByteOrder | null = null,
    public layouts: StructLayoutT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.structName === null || this.structName === undefined) {
      throw new Error('Required field "struct_name" is not set');
    }
    if (this.layouts === null || this.layouts === undefined) {
      throw new Error('Required field "layouts" is not set');
    }
    const structName = this.structName !== null ? builder.createString(this.structName!) : 0;
    const layouts = StructDecode.createLayoutsVector(
      builder,
      builder.createObjectOffsetList(this.layouts),
    );

    return StructDecode.createStructDecode(builder, structName, this.byteOrder, layouts);
  }

  clone(): StructDecodeT {
    const obj = new StructDecodeT();
    obj.structName = this.structName;
    obj.byteOrder = this.byteOrder;
    obj.layouts = this.layouts.map((e) => e.clone());
    return obj;
  }

  equals(other: StructDecodeT): boolean {
    if (this.structName !== other.structName) return false;
    if (this.byteOrder !== other.byteOrder) return false;
    if (this.layouts.length !== other.layouts.length) return false;
    for (let i = 0; i < this.layouts.length; i++) {
      const a = this.layouts[i];
      const b = other.layouts[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyStructDecode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "struct_name");
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyStructLayout);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "layouts");
  } finally {
    verifier.popDepth();
  }
}
